import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import store from './store/store';
import useAuth from './hooks/useAuth';
import AppRouter from './routes/AppRouter';
import CustomLoader from '@components/UI/CustomLoader/CustomLoader';

import Cookies from "js-cookie";
import api from '@modules/UserInfo/api';

const App = () => {
  const auth = useAuth();

  useEffect(() => {
    const getUserData = async (token: string) => {
      // Проверяем, не является ли текущий путь страницей регистрации /auth/:token/:email/:reset
      const currentPath = window.location.pathname;
      const isAuthPage = currentPath.startsWith('/auth/');
      const isPublicFileExchangeLink = currentPath.startsWith('/file-exchange/');
      
      if (!token && !isAuthPage && !isPublicFileExchangeLink) {
        // Определяем URL для редиректа в зависимости от окружения
        const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
        const loginUrl = isLocal 
          ? `http://localhost:5173/login`
          : "https://new.mycent.kz/login";
        window.location.replace(loginUrl);
        return;
      }

      if (token) {
        auth.setToken(token);
        const { data } = await api.getProfile();
        auth.setUser(data);
      }
    };
    
    const token = Cookies.get("token") || localStorage.getItem("token");
    getUserData(token);
  }, [])

  return auth.isLoaded ? (
    <>
      <Provider store={store}>
        <AppRouter />
      </Provider>
    </>
  ) : (
    <div
      style={{
        display: 'flex',
        minHeight: '100vh',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <CustomLoader />
    </div>
  );
};

export default App;
